var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo, useEffect, useState } from 'react';
import { getTheme, } from './themes';
var currentTheme = 'asurion';
var themeOverrides;
var themeStateUpdaters = [];
export var updateTheme = function (themeKey, overrides) {
    var theme = getTheme(themeKey);
    if (!theme)
        throw new Error("Could not find theme with name \"" + themeKey + "\"");
    currentTheme = themeKey;
    themeOverrides = overrides;
    themeStateUpdaters.forEach(function (f) { return f(currentTheme); });
};
export var useTheme = function () {
    var _a = useState(currentTheme), themeKey = _a[0], setThemeKey = _a[1];
    useEffect(function () {
        themeStateUpdaters.push(setThemeKey);
        return function () {
            themeStateUpdaters.splice(themeStateUpdaters.indexOf(setThemeKey), 1);
        };
    }, []);
    var theme = useMemo(function () {
        var theme = getTheme(themeKey);
        if (themeOverrides) {
            return __assign(__assign({}, theme), themeOverrides);
        }
        return theme;
    }, [themeKey, themeOverrides]);
    return theme;
};
